import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ReturnExceptionControllerService } from '@app/api/order-service/api/returnExceptionController.service';
import { ReturnExceptionSearchDTO } from '@app/api/order-service/model/returnExceptionSearchDTO';
import { ReturnExceptionSummaryVO } from '@app/api/order-service/model/returnExceptionSummaryVO';
import { ReturnExceptionVO } from '@app/api/order-service/model/returnExceptionVO';

export interface ReturnExceptionListItem extends ReturnExceptionSummaryVO {
  storeDisplay?: string;
}

export interface ReturnExceptionPageResult {
  items: ReturnExceptionListItem[];
  totalRecords: number;
}

@Injectable({
  providedIn: 'root',
})
export class ReturnExceptionFeatureService {
  private readonly api = inject(ReturnExceptionControllerService);

  page(search: ReturnExceptionSearchDTO): Observable<ReturnExceptionPageResult> {
    return this.api.page(search).pipe(
      map((page) => ({
        items: (page.pageContent ?? []).map((row) => this.toListItem(row)),
        totalRecords: page.totalElements ?? 0,
      })),
    );
  }

  getById(id: number): Observable<ReturnExceptionVO> {
    return this.api.getById(id);
  }

  approve(id: number): Observable<ReturnExceptionVO> {
    return this.api.approve(id);
  }

  cancel(id: number, cancelReason: string): Observable<ReturnExceptionVO> {
    return this.api.cancel(id, { cancelReason });
  }

  approveBatch(ids: number[]): Observable<ReturnExceptionVO[]> {
    return this.api.approveBatch({ ids });
  }

  cancelBatch(ids: number[], cancelReason: string): Observable<ReturnExceptionVO[]> {
    return this.api.cancelBatch({ ids, cancelReason });
  }

  private toListItem(row: ReturnExceptionSummaryVO): ReturnExceptionListItem {
    const code = row.storeCode?.trim();
    const name = row.storeName?.trim();
    let storeDisplay = name ?? code ?? '';
    if (code && name && code !== name) {
      storeDisplay = `${code} - ${name}`;
    }
    return {
      ...row,
      storeDisplay,
    };
  }
}
